export default __webpack_public_path__ + "static/media/grafema_minha-casa_01.feab59df.jpg";